"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionListToPayload = exports.unionToPayload = exports.Payload = void 0;
const bytes_js_1 = require("../../solarxr-protocol/datatypes/bytes.js");
const string_table_js_1 = require("../../solarxr-protocol/datatypes/string-table.js");
const key_values_js_1 = require("../../solarxr-protocol/pub-sub/key-values.js");
var Payload;
(function (Payload) {
    Payload[Payload["NONE"] = 0] = "NONE";
    Payload[Payload["solarxr_protocol_datatypes_StringTable"] = 1] = "solarxr_protocol_datatypes_StringTable";
    Payload[Payload["solarxr_protocol_datatypes_Bytes"] = 2] = "solarxr_protocol_datatypes_Bytes";
    Payload[Payload["KeyValues"] = 3] = "KeyValues";
})(Payload = exports.Payload || (exports.Payload = {}));
function unionToPayload(type, accessor) {
    switch (Payload[type]) {
        case 'NONE': return null;
        case 'solarxr_protocol_datatypes_StringTable': return accessor(new string_table_js_1.StringTable());
        case 'solarxr_protocol_datatypes_Bytes': return accessor(new bytes_js_1.Bytes());
        case 'KeyValues': return accessor(new key_values_js_1.KeyValues());
        default: return null;
    }
}
exports.unionToPayload = unionToPayload;
function unionListToPayload(type, accessor, index) {
    switch (Payload[type]) {
        case 'NONE': return null;
        case 'solarxr_protocol_datatypes_StringTable': return accessor(index, new string_table_js_1.StringTable());
        case 'solarxr_protocol_datatypes_Bytes': return accessor(index, new bytes_js_1.Bytes());
        case 'KeyValues': return accessor(index, new key_values_js_1.KeyValues());
        default: return null;
    }
}
exports.unionListToPayload = unionListToPayload;
